import React, { useCallback, useMemo, useState } from 'react';
import { Dropdown } from '../dropdown/dropdown';
import { context } from './utils';
import Button from './button';
import SimpleButton from './button.simple';
import Content from './content';
import Info from './info';
import Option from './option';
import OptionEmpty from './option-empty';
import Section from './section';
import Group from './group';
import Search from './search';
export const Select = ({ children, mode = 'single', onChange = () => { }, native = false, dataTest, onToggle = () => { }, }) => {
    const [info, setInfo] = useState({});
    const [search, setSearch] = useState({});
    const [nativeValue, setNativeValue] = useState(null);
    const [list, registerList] = useState(null);
    const [select, registerSelect] = useState();
    const showInfo = useCallback((show) => setInfo(prev => (Object.assign(Object.assign({}, prev), { show }))), []);
    const showSearch = useCallback((show) => setSearch(prev => (Object.assign(Object.assign({}, prev), { show }))), []);
    const registerInfoControl = useCallback((control) => setInfo(prev => (Object.assign(Object.assign({}, prev), { control }))), []);
    const registerSearchInput = useCallback((control) => setSearch(prev => (Object.assign(Object.assign({}, prev), { control }))), []);
    const contextValue = useMemo(() => ({
        list,
        select,
        info,
        mode,
        native,
        nativeValue,
        onChange,
        registerInfoControl,
        registerList,
        registerSearchInput,
        registerSelect,
        search,
        setNativeValue,
        showInfo,
        showSearch,
        dataTest,
    }), [
        list,
        select,
        info,
        mode,
        native,
        nativeValue,
        onChange,
        registerInfoControl,
        registerList,
        registerSearchInput,
        registerSelect,
        search,
        setNativeValue,
        showInfo,
        showSearch,
        dataTest,
    ]);
    if (native) {
        return React.createElement(SelectProvider, { value: contextValue }, children);
    }
    return (React.createElement(Dropdown, { onToggle: onToggle },
        React.createElement(SelectProvider, { value: contextValue }, children)));
};
function SelectProvider({ value, children, }) {
    return React.createElement(context.Provider, { value: value }, children);
}
Select.Button = Button;
Select.SimpleButton = SimpleButton;
Select.Content = Content;
Select.Info = Info;
Select.Option = Option;
Select.OptionEmpty = OptionEmpty;
Select.Section = Section;
Select.Group = Group;
Select.Search = Search;
//# sourceMappingURL=select.js.map